import React, { useState } from "react";
import styles from "./TermsAndConditions.module.css";
import { useAllProduct } from "../api-context/commonApiContext";
import Notification from "../Notification/Notification";

export default function TermsAndConditions({
  onBack = () => {},
  onSubmit = (agreed) => {
    alert(agreed ? "Submitted ✅" : "Please agree to the terms.");
  },
}) {
  const [submit, setSubmit] = useState(false);
  const { basicKyc } = useAllProduct();
  const [agreed, setAgreed] = useState(false);

  const handleSubmit = (e) => {
    console.log("hello");

    e.preventDefault();
    if (!agreed) return; // guard
    onSubmit(agreed);
    // 2) Only show Notification AFTER successful submit
    setSubmit(true);
  };
  console.log("basicKyc", basicKyc, submit);

  return (
    <>
      {submit ? (
        <div
          style={{
            minHeight: "70vh",
            display: "grid",
            placeItems: "center",
            padding: "16px",
          }}
        >
          <Notification
            title={basicKyc ? "Basic KYC done!" : ""}
            msg={
              basicKyc
                ? "Your onboarding has begun, a welcome email will reach you soon."
                : ""
            }
            buttonName={basicKyc ? "Proceed to Advanced KYC" : ""}
            link={basicKyc ? "/advanced-kyc" : ""}
          />
        </div>
      ) : (
        <>
          {" "}
          <div className={`mt-2 mb-5 ${styles.subTitle}`}>
            To get started with CUPI, you need to accept the following Terms &
            Conditions.
          </div>
          <div className={styles.page}>
            <form
              id="termsForm"
              className={styles.card}
              onSubmit={handleSubmit}
            >
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  Terms of Use to be read carefully as they constitute a legal
                  agreement between CUPI (Escrow Stack Private Limited) and:{" "}
                </h2>
                <ul className={styles.list}>
                  <li>
                    A User of CUPI Application/CUPI Website Dashboard/ CUPI
                    Wallet/Access to CUPI Expense management solution and its
                    services;
                  </li>
                  <li>
                    An establishment that allows its customers the option to
                    make a purchase/payment using their CUPI expense management
                    solution and/or its services provided under CUPI’s
                    co-branded arrangement; or
                  </li>
                  <li>An internet surfer.</li>
                  <li>Any more things can be added as per requirements</li>
                </ul>
                <p className={styles.note}>
                  This document is an electronic record under the Information
                  Technology Act, 2000. It is published in accordance with
                  applicable rules (including, as relevant, the Information
                  Technology (Intermediary Guidelines and Digital Media Ethics
                  Code) Rules, 2021, as amended). Escrow Stack Private Limited
                  (including its affiliates) provides the CUPI
                  expense-management platform. CUPI is a platform to Users on
                  which they can make payments towards business expenses
                  authorised by their employer(s). CUPI has its registered
                  office situated at
                  <b>
                    {" "}
                    4th Floor, Building No: 50, 11th Main Road, Pattabhirama
                    Nagar, Jayanagar, Bengaluru, Karnataka, PIN Code: 560011,
                    India
                  </b>
                  .
                </p>
                <p className={styles.note}>
                  CUPI appreciates the support from everyone who contributes
                  their time, resources, or money to help us continue our work.
                  We are committed to maintaining strict privacy policies to
                  protect the personal information of our users and visitors,
                  whether gathered through our communication channels or our
                  website. CUPI does not sell, exchange, or rent your personal
                  information to any organization or individual. We use and
                  share personal information only to provide services, improve
                  security and performance, and comply with law.
                </p>
              </section>

              <section className={styles.section}>
                <h2 className={styles.heading}>
                  What information do we gather?
                </h2>
                <p className={styles.note}>
                  When you sign up, leave a query, or transact with CUPI, we may
                  request information such as your name, address, email address,
                  phone number, and other relevant details. CUPI uses cookies to
                  facilitate authentication and personalization across our web
                  systems. A cookie is a small piece of data sent to your web
                  browser from a web server and stored on your computer’s hard
                  drive. CUPI uses only anonymous information (such as IP
                  addresses) to track how our online visitors use our website.
                  This data is sometimes stored using cookies.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  How is your information used?
                </h2>
                <p className={styles.note}>
                  CUPI is dedicated to safeguarding the privacy and
                  confidentiality of your personal information. Whenever we
                  collect personal information from you, our website employs
                  commercially reasonable efforts and general industry standards
                  to protect it from unauthorized access or disclosure. We value
                  the privacy and security of our users' sensitive personal data
                  and information. Therefore, we strictly adhere to obtaining
                  explicit consent and approval from information providers
                  before collecting and processing any sensitive personal data
                  or information.
                </p>
                <p className={styles.note}>
                  Access to your personal information is restricted to CUPI
                  personnel and authorized third parties who may host your data
                  on our behalf or assist us in providing the products and
                  services you request. With your approval, we will collect,
                  store, use, and disseminate data in accordance with the
                  Aadhaar (Sharing of Information) Regulations 2016 and related
                  rules and regulations. CUPI will take necessary steps to
                  encrypt or anonymize such data to ensure compliance with these
                  regulations.
                </p>
                <p className={styles.note}>
                  CUPI employs physical, electronic, and procedural safeguards
                  to protect your information against loss, misuse, damage,
                  modification, and unauthorized access or disclosure. However,
                  CUPI assumes no liability for any disclosure of personal
                  information due to unauthorized third-party access or other
                  acts of third parties, or any acts or omissions beyond our
                  reasonable control.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  CUPI uses personal information to operate, provide, secure,
                  and improve CUPI. This includes (without limitation):
                </h2>
                <ul className={styles.list}>
                  <li>
                    <b>Accounts & access:</b> create/manage accounts,
                    authenticate users, manage roles.
                  </li>
                  <li>
                    <b>Transactions & communications:</b> process
                    payments/wallet loads/refunds/fees; send receipts, OTPs,
                    alerts, and service updates.
                  </li>
                  <li>
                    <b>Safety & compliance:</b> prevent/detect/investigate fraud
                    or misuse; KYC/AML and legal/regulatory obligations; enforce
                    these Terms.
                  </li>

                  <li>
                    <b>Product & analytics:</b> maintain and enhance features,
                    performance, and reliability; conduct usage analytics; use
                    aggregated/de-identified data.
                  </li>
                  <li>
                    <b>Marketing (consent-based):</b> send offers/features where
                    permitted; you can opt out anytime.
                  </li>
                  <li>
                    We share information with <b> service providers </b>and{" "}
                    <b>partner banks/RBI/NPCI</b> as and when needed to deliver
                    the Services and comply with law.{" "}
                    <b>We do not sell personal information.</b>
                  </li>
                </ul>
                <p className={styles.note}>
                  CUPI uses non-identifying basic information (aggregate data)
                  to analyze site usage and improve the content and design of
                  the site. We may share aggregate data with sponsors and
                  partners. These statistics will not include any personally
                  identifying information.
                </p>
                <p className={styles.note}>
                  Our website has stringent security measures in place to
                  protect against the loss, misuse, and alteration of the
                  information under our control. CUPI will not use personal
                  information in any way other than as described in our Terms &
                  Conditions. The only exception is sharing personal information
                  to cooperate with law enforcement officials.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Is your transaction safe?</h2>
                <p className={styles.note}>
                  Absolutely. The security and confidentiality of your
                  information are our highest priorities. We use
                  industry-standard SSL (Secure Socket Layer) technology to
                  protect your information and ensure a safe and secure
                  environment for online transactions.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Liability</h2>
                <p className={styles.note}>
                  Our website may link to other sites that collect identifiable
                  information about you. CUPI cannot ensure those sites’ privacy
                  practices and is not responsible for any damages they cause.
                  By using our website or providing information on it, you
                  consent to our collection and use of your information in line
                  with this Privacy Policy and agree to be bound by its terms.
                  For questions, comments, or to update your personally
                  identifiable information, email{" "}
                  <a href="mailto:contact@getcupi.com" className={styles.link}>
                    contact@getcupi.com
                  </a>
                  . CUPI may change this Privacy Policy at any time; please
                  review it periodically to stay informed.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Refunds</h2>
                <p className={styles.note}>
                  By accepting these Terms, you agree to be legally bound by
                  them. Amounts loaded into your CUPI wallet and any fees
                  already paid are non-refundable and non-cancellable, except
                  where required by law or when User requests to close their
                  CUPI account as expressly stated in these Terms.
                </p>
                <p className={styles.note}>
                  These Terms, together with our Privacy Policy, govern your use
                  of the CUPI mobile app, web dashboard, and related services,
                  and explain how we manage your account. If you have any
                  questions about our terms, contact us at:{" "}
                  <a href="mailto:care@getcupi.com" className={styles.link}>
                    care@getcupi.com
                  </a>
                  .
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>YOUR AGREEMENT WITH CUPI</h2>
                <ul className={styles.list}>
                  <li>
                    You authorize us, including any third party engaged by us,
                    to undertake your KYC as required from time to time. We may
                    use third-party services to complete your KYC.
                  </li>
                  <li>
                    You may be required to share copies of your documents and
                    additional information needed to verify your identity.
                  </li>
                  <li>
                    KYC collection, verification, audit, and maintenance is a
                    continuous process. We reserve the right at any time to take
                    steps necessary to ensure compliance with all applicable KYC
                    requirements.
                  </li>
                  <li>
                    If you refuse to share information for KYC, we may deny or
                    limit your use of the CUPI Expense Management solution.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>APPROVAL OF TERMS </h2>
                <ul className={styles.list}>
                  <li>
                    By using the Application/Services/Website, you agree that
                    you have read and understood these Terms and you agree to be
                    bound by these Terms and use the Services in compliance with
                    these Terms. Please read these Terms carefully. If you do
                    not agree to be bound by (or cannot comply with) any of the
                    terms below, please leave the Application/Services/Website
                    immediately and terminate your account with us. The
                    information that you obtain or receive from CUPI, its Team,
                    contractors, partners, sponsors, advertisers, or otherwise
                    on the Website is for informational and scheduling purposes
                    only.
                  </li>
                  <li>
                    The information provided on the Application/Website is not
                    professional advice and must not be considered as such. Your
                    use of information provided on the Application /website is
                    solely at your own risk.
                  </li>
                  <li>
                    You can accept the Terms by:
                    <ul className={styles.list}>
                      <li>
                        Accessing or using the CUPI application, website
                        dashboard, or any Services (including by clicking{" "}
                        <b>“I agree”</b> or similar where presented). Your first
                        access or use will be deemed acceptance of these Terms
                        from that time onward.{" "}
                      </li>
                      <li>
                        For being a valid User, you must satisfy the following
                        conditions:
                        <ul className={styles.list}>
                          <li>
                            You are of legal age to form a binding contract with
                            CUPI; and
                          </li>
                          <li>
                            You are not a person barred from receiving the
                            Services under the laws of India.{" "}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>KYC Verification</h2>
                <p className={styles.note}>
                  You authorize us, including any third-party that may be
                  engaged by us to undertake your KYC process as may be required
                  from time to time. You agree and acknowledge that we may use
                  the services of a third-party to complete your KYC process.
                  You may be required to share with us copies of your documents
                  and any other additional information that we may require to
                  verify your identity. The collection, verification, audit and
                  maintenance of the correct and updated information about you
                  is a continuous process, so we reserve the right at any time,
                  to take steps necessary to ensure compliance with all
                  applicable KYC requirements. If you refuse to share your
                  information for the KYC process, we may need to deny or limit
                  your use of CUPI Expense Management solution.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  User’s relationship with CUPI which provides Expense
                  management solution and services to make UPI payments:{" "}
                </h2>
                <p className={styles.note}>
                  CUPI will enable you to load money into wallet, use the CUPI
                  expense management solution and its services (if you
                  successfully complete the complete KYC process and any other
                  requirements that we may prescribe from time to time). CUPI
                  will allow your users to use the CUPI app to make UPI payments
                  via CUPI expense management solution. CUPI provides and
                  maintains the Platform through which you can access your CUPI
                  Account.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>CUPI policies</h2>
                <p className={styles.note}>
                  As CUPI Expense Management solution is provided by CUPI, it is
                  your responsibility to visit CUPI's Website on a regular basis
                  to obtain the latest updates on policies for CUPI.
                </p>
                <p className={styles.note}>
                  Refer below links to access Terms and Conditions:
                </p>
                <p className={styles.note}>
                  Terms and Conditions:&nbsp;
                  <a
                    href="https://www.getcupi.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                  >
                    https://www.getcupi.com/terms
                  </a>
                </p>

                <p className={styles.note}>
                  FAQ:&nbsp;
                  <a
                    href="https://www.getcupi.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                  >
                    https://www.getcupi.com/
                  </a>
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Definitions:</h2>
                <ul className={styles.list}>
                  <li>
                    <b>CUPI:</b> CUPI – Corporate UPI Expense Management by
                    Escrow Stack Private Limited, incorporated in India;
                    registered office: No 50, 4th Flr, 11th Main, 4th
                    Blk,Pattabhiramanagar,Jayangar III Block, Bangalore,
                    Bangalore South, Karnataka,India, 560011.
                  </li>
                  <li>
                    <b>Available Balance:</b> For a CUPI Account, the amount
                    available at a given time means funds loaded to CUPI minus
                    amounts spent and applicable CUPI fees/charges.
                  </li>
                  <li>
                    <b>Transaction:</b> Any instruction that moves or affects
                    money in CUPI like a UPI payment, wallet load, reversal, or
                    fee for using the CUPI app, web dashboard, or approved
                    channels. It counts when recorded by CUPI or our bank/
                    partners, even if it later succeeds, fails, or stays
                    pending.{" "}
                  </li>
                  <li>
                    <b>Know Your Customer (KYC):</b> RBI norms/rules/laws under
                    which CUPI must obtain your personal identification details
                    before delivering services.{" "}
                  </li>
                  <li>
                    <b>Posted Information:</b> content you share with CUPI
                    (messages, receipts, forms, uploads, comments, files) via
                    the app or dashboard.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Disputes</h2>
                <p className={styles.note}>
                  All the transaction disputes related to network shall be
                  governed as per network guidelines by CUPI. CUPI will be the
                  sole arbitrator in these disputes between the CUPI Account
                  Holder and the Merchant.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  INFORMATION PRESENTATION/EDITORIAL CONTROL{" "}
                </h2>
                <ul className={styles.list}>
                  <li>
                    We make the Application/Services/Website available as part
                    of our Service to Users. We may, but are not obligated, to
                    have content present on our Application/Services/Website
                    reviewed by the Application/Services/Website’s personnel.
                  </li>
                  <li>
                    Authors, editorial personnel, and all others involved do not
                    assure that the information is accurate or complete in every
                    respect and are not responsible for any errors/omissions or
                    for results obtained from using such information.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  USE OF SERVICES AND INFORMATION ON THE Application/WEBSITE
                </h2>
                <ul className={styles.list}>
                  <li>
                    To access certain Services, you may need to provide
                    identification, contact, or payment details during
                    registration or ongoing use. All information you provide
                    must be true, accurate, correct, complete, and up to date.
                    The phone number used to register must be in your name, and
                    you may be asked for supporting documents.
                  </li>
                  <li>
                    Under the Information Technology Act, 2000 read with the
                    Information Technology (Intermediary Guidelines) Rules,
                    2011, CUPI securely transmits and saves your data— including
                    your in-app interactions, transactions via CUPI, and SMS
                    exchanges—to our secure servers, to serve you better offers,
                    reminders, and notifications aligned with your interests.
                  </li>
                  <li>
                    <b>Permitted use & access controls:</b>
                    <ul>
                      <li>
                        Do not use information from the Application/Website for
                        any unauthorized or unlawful purpose.{" "}
                      </li>
                      <li>
                        Access Services only through the CUPI interface, unless
                        a separate agreement allows otherwise.
                      </li>
                      <li>
                        Do not interfere with or disrupt the Services or related
                        servers/networks.
                      </li>
                      <li>
                        Do not reproduce, duplicate, copy, transfer, license,
                        rent, sell, trade, or resell information obtained from
                        the Application/Website for any purpose.
                      </li>
                      <li>
                        Do not impersonate any person (including a user or
                        Merchant).
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>Responsibility, privacy & consent:</b> You are solely
                    responsible for any breach of these Terms and its
                    consequences (including any loss or damage to CUPI). You
                    agree to the use of your data in accordance with CUPI’s
                    Privacy Policy. All personal and contact information you
                    provide (including for account creation and administration)
                    will be kept confidential by CUPI.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>CONTENT YOU POST OR SUBMIT</h2>
                <ul className={styles.list}>
                  <li>
                    When using interactive features to contact our Team and
                    share “Posted Information,” act responsibly: no
                    inappropriate language or gratuitous personal criticisms;
                    include all relevant details concisely to help us respond.
                  </li>
                  <li>
                    You are solely responsible for Posted Information you submit
                    or transmit.
                  </li>
                  <li>
                    Do not post, distribute, or reproduce
                    copyrighted/trademarked/proprietary material without the
                    owner’s prior written consent. Do not submit content that
                    infringes any party’s IP, publicity, privacy, or other
                    rights. Do not state or imply CUPI sponsors or endorses your
                    content.
                  </li>
                  <li>
                    Do not submit unlawful content or content that
                    promotes/encourages illegal activity.
                  </li>
                  <li>
                    CUPI may (but is not obligated to) review and delete any
                    Posted Information that, in CUPI’s sole discretion, violates
                    these Terms or may be offensive, illegal, or threaten
                    others’ rights/safety. You agree to provide only true
                    information and not intentionally provide false or
                    misleading information. CUPI may investigate, remove
                    offending content, terminate memberships, or block use of
                    the Services/Website.
                  </li>
                  <li>
                    Prohibited content & communications:
                    <ul>
                      <li>Unsolicited mass mailings/spam.</li>
                      <li>Harassment or advocacy of harassment.</li>
                      <li>False or intentionally misleading content.</li>
                      <li>IP violations or other rights violations.</li>
                      <li>
                        Threatening, obscene, defamatory, or libelous content.
                      </li>
                      <li>Pornographic or sexually explicit content.</li>
                    </ul>
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  Further prohibitions (you agree not to post/use content that
                  is):{" "}
                </h2>
                <ul className={styles.list}>
                  <li>
                    Unlawful, false/defamatory, inaccurate, abusive, vulgar,
                    hateful, harassing, libelous, harmful, obscene, profane,
                    sexually-oriented, threatening, racially offensive, invasive
                    of privacy, or otherwise objectionable.
                  </li>
                  <li>
                    Offensive, inaccurate, misleading, pornographic, harassing,
                    libelous, blasphemous, defamatory, obscene, paedophilic,
                    invasive of privacy, hateful, racially or ethically
                    objectionable, disparaging, related to or encouraging money
                    laundering or gambling, or otherwise inappropriate.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  Operational & safety commitments (you also agree to):
                </h2>
                <ul className={styles.list}>
                  <li>
                    Not upload/share information that impersonates another
                    person or threatens the unity, integrity, defence, security,
                    or sovereignty of India.
                  </li>
                  <li>
                    Obtain all required consents/permissions/licenses before
                    submitting material.
                  </li>
                  <li>Respect others’ privacy.</li>

                  <li>
                    Not distribute/post spam, unreasonably large files, chain
                    letters, pyramid schemes, or viruses.
                  </li>
                  <li>
                    Not use technologies or initiate activities that may harm
                    the Service or users’ interests/property.
                  </li>
                  <li>
                    Not use automated systems or means to
                    access/acquire/copy/monitor any part of the Service.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  If you find objectionable content, notify the CUPI helpdesk.
                  CUPI will use its best efforts to remove such content within
                  24 hours of due notice.
                </h2>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>YOUR USE OF INFORMATION</h2>
                <ul className={styles.list}>
                  <li>
                    Except for your Posted Information, all content on/through
                    the Application/Services/Website (text, photos, graphics,
                    audio/video, etc.) is owned by us/our licensors and
                    protected by copyright, trademark, patent, trade secret,
                    other proprietary rights, and international treaties. The
                    Services and underlying technology/software contain CUPI
                    proprietary information. We permit personal, non-commercial
                    use only; no IP rights are transferred. You may
                    print/download/store content for your convenience, but you
                    may not copy, distribute, republish (except as permitted),
                    sell, or exploit any content or the Website in whole or in
                    part for any commercial purpose. Except as expressly stated,
                    no rights are granted; all rights in the
                    Application/Services/Website remain with CUPI.
                  </li>
                  <li>
                    We make no guarantees/representations/warranties (express or
                    implied) regarding the Team’s professional qualifications,
                    expertise, quality of work/Services, or other related
                    information.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  PRIVACY AND INTELLECTUAL PROPERTY PROTECTION{" "}
                </h2>
                <ul className={styles.list}>
                  <li>
                    CUPI’s Privacy Policy explains how we treat your personal
                    data and protect your privacy. By using the Services, you
                    agree CUPI may use your data in line with that policy.
                  </li>
                  <li>
                    You are responsible for keeping your account access
                    credentials confidential.
                  </li>
                  <li>
                    You are solely responsible to CUPI for all activity under
                    your account. If you suspect unauthorized use of your
                    password or account, notify the CUPI helpdesk immediately.
                  </li>
                  <li>
                    Intellectual property & permitted use:
                    <ul>
                      <li>
                        CUPI owns all CUPI trademarks/brands/service marks and
                        all copyrights and database rights in the Services.
                      </li>
                      <li>
                        You may not publish, distribute, extract, or reproduce
                        Service content without CUPI’s consent.{" "}
                      </li>
                      <li>
                        For any third-party intellectual property, you must
                        obtain permission directly from the owner. Third-party
                        trademarks may appear on the Website; all rights are
                        reserved to their registered owners.{" "}
                      </li>
                      <li>
                        You acknowledge that any IP not stated as CUPI-owned
                        belongs to its respective owners, who may take action
                        for violation, infringement, or passing off.{" "}
                      </li>
                      <li>
                        Your use of the Services is governed by laws on
                        copyright, trademark, patent, and trade secrets. You
                        agree not to
                        upload/download/display/perform/transmit/distribute any
                        content that violates any party’s IP or proprietary
                        rights, and you are solely responsible for any such
                        violations caused by your use of the
                        interface/Application/Services/Website.
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  THIRD-PARTY INFORMATION ON THE Application/WEBSITE{" "}
                </h2>
                <ul className={styles.list}>
                  <li>
                    Some information is provided by third parties. CUPI has no
                    liability for any loss/damage arising from such
                    information—including how it is displayed—or if it is out of
                    date, inaccurate, a duplication, or involves impersonation.
                  </li>
                  <li>
                    Any communication or dealings facilitated between a Merchant
                    and a user are solely between them. CUPI is not responsible
                    for such communications and has no liability for those
                    dealings.
                  </li>
                  <li>
                    CUPI is not an agent for any Merchant listed on the
                    Application/Services/Website and has no responsibility or
                    liability for any Merchant’s conduct or quality of service.{" "}
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>LINKS TO OTHER SITES</h2>
                <ul className={styles.list}>
                  <li>
                    Services may link to other websites that could contain
                    objectionable, unlawful, or inaccurate material. These links
                    are for your convenience only and do not mean we endorse
                    those sites or their products/Services. You acknowledge we
                    are not responsible or liable for their content or accuracy.
                  </li>
                  <li>
                    Every webpage on our Application/Services/Website begins
                    with <b>“https://”</b> —i.e., it is <b> HTTPS-enabled</b>/
                    “identity verified.”
                  </li>
                  <li>
                    <b>Your caution & our liability:</b> Our entire
                    Wallet/Website is HTTPS-enabled to help protect you from
                    dummy websites. Always verify HTTPS before sharing any
                    information. We are not liable for any consequences of you
                    providing details on any third-party site, including dummy
                    websites.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>NO WARRANTIES</h2>
                <ul className={styles.list}>
                  <li>
                    Your access to and use of the App, Website, and Services is
                    conditioned on your acceptance of and compliance with these
                    Terms.
                  </li>
                  <li>
                    <b>Disclaimer of warranties (express & implied): </b>
                    <ul>
                      <li>
                        We do not warrant that the Wallet/Website will always
                        work without disruptions, delays, or errors. Quality may
                        be affected by your local network, firewall, ISP, the
                        public internet, public/private switched mobile
                        networks, and your power supply. We are not responsible
                        for disruptions caused by these or any other factors
                        beyond our control.{" "}
                      </li>
                      <li>
                        We do not warrant your ability to use the Service
                        through the Application/Services/Website.{" "}
                      </li>
                      <li>No satisfaction guarantee.</li>
                      <li>No data security/privacy warranty. </li>
                      <li>No bug/error correction warranty. </li>
                      <li>
                        Services may not be compatible with all broadband
                        services or modems; we disclaim any express or implied
                        compatibility warranties.{" "}
                      </li>
                      <li>
                        We make no representations or warranties, including
                        implied warranties of merchantability, fitness for a
                        particular purpose, or non-infringement. No one is
                        authorized to make a warranty on our behalf; you may not
                        rely on any such statements.
                      </li>
                      <li>
                        Our Team members who furnish Services under this
                        Agreement are not liable for any act or omission
                        relating to the Application/Services/Website.{" "}
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>RESTRICTIONS ON USE </h2>
                <h2 className={styles.heading}>
                  In addition to all Terms of this Agreement, you shall not:
                </h2>
                <ul className={styles.list}>
                  <li>
                    Access/use third-party sites via links without agreeing to
                    their terms, or post links/use their logo, company name, or
                    other marks without prior <b>written</b> permission.
                  </li>
                  <li>
                    Use the Services for spamming or any <b> illegal</b>{" "}
                    purpose.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>TERMINATION OF SERVICES</h2>
                <p className={styles.note}>
                  Your account may be disabled and Services terminated based on
                  your representations. Termination may result from:
                </p>
                <ul className={styles.list}>
                  <li>
                    Impersonating people, entities, the Services, or CUPI Team;
                    creating or implying our creation/sponsorship/endorsement of
                    your content; manipulating identifiers to disguise origin;
                    or creating accounts by automated means or under
                    false/fraudulent pretences.
                  </li>
                  <li>
                    Posting or sending content harmful or detrimental to
                    CUPI/its associates, or violating CUPI/associate
                    restrictions or policies.
                  </li>
                  <li>
                    Falsifying or deleting author attributions, legal notices,
                    proprietary designations, or source labels in posted files.
                  </li>
                  <li>
                    Uploading content containing viruses, trojan horses, or
                    other code that interrupts, destroys, or limits
                    functionality.
                  </li>
                  <li>
                    Collecting or storing other users’ personal data, or using
                    robots/spiders/search or retrieval tools to index the
                    Service or collect user information for unauthorized
                    purposes.{" "}
                  </li>
                  <li>
                    Interfering with or disrupting the Service/servers/networks,
                    or disobeying network requirements, procedures, policies, or
                    regulations.{" "}
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>SPAMMING</h2>

                <ul className={styles.list}>
                  <li>
                    You may not use the contact information provided by us or
                    other users or harvest such information for the purpose of
                    sending, or to facilitate the sending, of unsolicited bulk
                    communications such as spam. You may not allow others to use
                    your account to violate the terms of this section. We may
                    terminate your membership or access to the
                    Application/Services/Website immediately and take other
                    legal action if you or anyone using your Credentials
                    violates these provisions.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>ADDITIONAL TERMS</h2>
                <p className={styles.note}>
                  Certain Services on the Application/Services/Website may have
                  additional terms (such as policies, guidelines, and rules)
                  that will further govern your use of that particular Service
                  and supplement these Terms. If you choose to register for or
                  access any such Services, you may be presented with any
                  relevant additional terms and conditions at that time. By
                  using those Services, you agree to comply with such additional
                  guidelines and rules.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>DISCLAIMER</h2>

                <ul className={styles.list}>
                  <li>
                    The Service and Application/Services/Website (and all
                    contents) are provided as is. CUPI and its officers,
                    employees, agents, and contractors make no express or
                    implied warranties about suitability, completeness,
                    accuracy, reliability, security, or availability, and accept
                    no responsibility (including for negligence) for errors or
                    omissions in the Service or Website.
                  </li>
                  <li>
                    CUPI and its officers, employees, agents, and contractors
                    are not liable for any loss, damage, claim, expense, cost
                    (including legal costs), or liability arising directly or
                    indirectly from your use or non-use of the Service/Website,
                    or reliance on them (whether due to CUPI’s or anyone else’s
                    negligence or otherwise). Any cause of action must be
                    commenced within 12 months after it accrues or you become
                    aware of the facts (whichever is later), otherwise it is
                    permanently barred. If any law implies a
                    term/condition/representation/warranty and does not allow
                    its exclusion, that item is included.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  GENERAL LIMITATION OF LIABILITY AND INDEMNIFICATION
                </h2>

                <ul className={styles.list}>
                  <li>
                    Your sole remedy is suspension of your CUPI account. We are
                    not liable for any
                    indirect/special/incidental/consequential/exemplary damages
                    (including lost profits, data, goodwill, work stoppage, or
                    computer failures), even if foreseeable.
                  </li>
                  <li>
                    You agree to defend, indemnify, and hold CUPI and its Team
                    harmless from any claims, actions, liabilities, judgments,
                    settlements, and reasonable legal fees arising from or
                    alleged to arise from your use of the
                    Application/Services/Website.
                  </li>
                  <li>
                    You also indemnify and hold CUPI and its Team harmless from
                    any loss, costs, damages, expenses, and liability caused by
                    your use of the Wallet/Website, your breach of this
                    Agreement, or your violation of any third-party rights
                    through the Application/Services/Website.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>UNENFORCEABLE PROVISIONS</h2>

                <ul className={styles.list}>
                  <li>
                    If any provision of these Terms is, or is found to be,
                    unenforceable under applicable laws, that will not affect
                    the enforceability of the other provisions of these Terms.
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  GOVERNING LAW AND DISPUTE RESOLUTION{" "}
                </h2>

                <ul className={styles.list}>
                  <li>
                    Except as otherwise described, all content on the
                    Application/Services/Website/interface is provided only to
                    facilitate users. CUPI controls and operates the
                    Application/Services/Website and Services and makes no
                    representation that the contents or Services are appropriate
                    or available for use in other locations. If you use the
                    Services from a location other than where they are
                    controlled and operated, you are responsible for complying
                    with applicable local laws.
                  </li>
                  <li>
                    These Terms are governed by the laws of India. All disputes
                    relating to these Terms shall be settled in the courts
                    located at Bangalore, India.{" "}
                  </li>
                </ul>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Fees and Charges:</h2>
                <p className={styles.note}>
                  CUPI reserves its right, in its sole discretion and without
                  any prior notice, to impose and/or revise charges/commissions
                  in relation to the use of your CUPI product. The current
                  charges for using CUPI will be shared by us with you on the
                  Email/Phone number which is provided by you to us at the time
                  of CUPI Onboarding registration or will be made visible to you
                  on the CUPI Dashboard at the time of our choosing, the same
                  are subject to change.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>Schedule of charges for CUPI</h2>
                <p className={styles.note}>
                  Fees will be charged from your wallet balance and disclosed
                  event-wise. You agree and acknowledge that CUPI is only a
                  facilitator and does not and cannot be a party to, or control
                  in any manner, any transactions for purchasing goods and/or
                  services using the CUPI Wallet. Uninstalling the CUPI app is
                  not the same as deleting your CUPI account; even after
                  uninstalling, your CUPI account (with or without any balance)
                  continues to be maintained by CUPI. Therefore, please keep
                  logging in to the CUPI platform and use the services on the
                  platform.
                </p>
              </section>
              <section className={styles.section}>
                <h2 className={styles.heading}>
                  To delete your CUPI account permanently, follow the steps
                  below:
                </h2>
                <p className={styles.note}>
                  Please write to us on{" "}
                  <a href="mailto:care@getcupi.com" className={styles.link}>
                    care@getcupi.com
                  </a>
                  {""} stating your CUPI account details and reason for account
                  deletion request.
                </p>
                <p className={styles.note}>
                  For any queries on the CUPI Expense Management Solution, you
                  can reach out to us on the help section of your CUPI app and
                  website dashboard. Alternatively, contact us on {""}
                  <a href="mailto:contact@getcupi.com" className={styles.link}>
                    contact@getcupi.com
                  </a>
                  .
                </p>
              </section>
            </form>
          </div>
          {/* <div className={styles.footer}>
            <label className={styles.agreeWrap}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
              <span className={styles.agreeText}>
                <b>*</b> I Agree, to the Terms &amp; Condition.
              </span>
            </label>

            <div className={styles.actions}>
              <button
                type="button"
                className={`${styles.btn} ${styles.btnGhost}`}
                onClick={onBack}
              >
                Back
              </button>
              <button
                form="termsForm"
                type="submit"
                className={`${styles.btn} ${styles.btnPrimary} ${
                  !agreed ? styles.btnDisabled : ""
                }`}
                disabled={!agreed}
                aria-disabled={!agreed}
              >
                Submit
              </button>
            </div>
          </div> */}
        </>
      )}
    </>
  );
}
